module.exports = __webpack_public_path__ + "assets/img/tg.806e39ab.png";